<template>
	<div>
		<div class="input-container">
			<div class="input-checkbox">
				<span class="checkmark-container">
					<label class="checkbox">
						<input type="checkbox" :id="`display-logic-${ value.id }`" v-model="value.config.has_display_conditions">
						<span class="checkmark"></span>
					</label>
				</span>
				<label :for="`display-logic-${ value.id }`" class="input-checkbox-text">Add Conditional Display Logic</label>
			</div>
		</div>
		<div v-if="value.config.has_display_conditions">
			<div class="input-container">
				<div class="input-static-text">
					If <select v-model="value.config.display_condition_grouping" :settings="{ create: false }">
						<option value="all">all</option>
						<option value="any">any</option>
					</select> of these conditions are met
				</div>
			</div>
			<div v-for="condition in fieldConfig.display_conditions" :key="`condition-${ condition.id }`" class="input-container">
				<div class="input-box add-border-bottom">
					<selectize v-model="condition.field" :settings="{ create: false }">
						<option v-for="field in otherFields" :key="`field-${ value.id }-filter-field-${ field.id }`" :value="field.slug">{{ field.name }} ({{ field.slug }})</option>
					</selectize>
				</div>
				<div class="input-box add-border-bottom">
					<selectize v-model="condition.operand" :settings="{ create: false }">
						<option value="=">is equal to</option>
						<option value="!=">is not equal to</option>
						<option value="empty">is empty</option>
						<option value="not empty">is not empty</option>
					</selectize>
				</div>
				<!-- TODO - Disable this when not applicable (e.g. operand === 'is empty') -->
				<div class="input-box add-border-bottom"><input v-model="condition.value" type="text"></div>
				<div class="inline-buttons">
					<a href @click.prevent="() => removeCondition(condition.id)" class="input-icon-button" tabindex="-1"><span class="fa fa-minus"></span></a>
					<a href @click.prevent="addCondition" class="input-icon-button" tabindex="-1"><span class="fa fa-plus"></span></a>
				</div>
			</div>
		</div>
		<div class="input-container">
			<div class="input-checkbox">
				<span class="checkmark-container">
					<label class="checkbox">
						<input type="checkbox" :id="`restricted-access-${ value.id }`" v-model="value.config.restricted_access">
						<span class="checkmark"></span>
					</label>
				</span>
				<label :for="`restricted-access-${ value.id }`" class="input-checkbox-text">Restrict to Admins</label>
			</div>
		</div>
	</div>
</template>

<script>

import _ from 'underscore';
import { v4 as uuidv4 } from 'uuid';

export default {

	props: {
		value: {
			required: true,
		},
		module: {
			type: Object,
			default: () => ({}),
		},
	},

	watch: {
		'value.config.has_display_conditions': function(hasDisplayLogic) {
			if (hasDisplayLogic) {
				if (this.fieldConfig.display_conditions.length === 0) {
					this.addCondition();
				}
			}
		},
	},

	computed: {

		fieldConfig() {
			return this.value.config || {};
		},

		otherFields() {
			return this.module.fields.filter(field => field.id !== this.value.id);
		},

	},

	created() {
		let conditions = this.fieldConfig.display_conditions || [];

		this.$set(this.fieldConfig, 'has_display_conditions', this.fieldConfig.has_display_conditions || false);
		this.$set(this.fieldConfig, 'display_condition_grouping', this.fieldConfig.display_condition_grouping || 'all');
		this.$set(this.fieldConfig, 'display_conditions', conditions);

		this.$set(this.fieldConfig, 'restricted_access', this.fieldConfig.restricted_access || false);
	},

	methods: {

		addCondition() {
			this.value.config.display_conditions.push({
				id: uuidv4(),
				operand: '=',
			});
		},

		removeCondition(id) {
			this.$set(this.fieldConfig, 'display_conditions', this.fieldConfig.display_conditions.filter(condition => condition.id !== id));

			if (this.fieldConfig.display_conditions.length === 0) {
				this.addCondition();
			}
		}

	},

};

</script>
